module.exports = __webpack_public_path__ + "static/media/prof-visio.abd577b8.png";